import React from 'react';
import logo_wide from '@tcc-online/assets/logos/tcc_online_wide.svg';
import logo from '@tcc-online/assets/logos/tcc_online.svg';
import { useSelector } from 'react-redux';
import InfoSelectors from '../../../selectors/InfoSelectors';
import RegistrationSlice from '../../../common/slices/RegistrationSlice';
import resolveCompanyLogoUrl from '../../../helpers/resolveCompanyLogoUrl';

export interface LogoProps extends React.HTMLAttributes<HTMLImageElement> {
    isWide?: boolean;
}

export default function Logo(props: LogoProps) {
    const { style, isWide = false } = props;
    const infoData = useSelector(InfoSelectors.getData);
    const { data: registration } = useSelector(RegistrationSlice.state.getAll);

    const isWhitelabel = infoData?.customization?.whitelabel === true;
    const companyLogoUrl = resolveCompanyLogoUrl(
        registration?.companyLogo,
        infoData?.logo,
    );
    const imageSrc = resolveImageSrc(companyLogoUrl, isWhitelabel, isWide);

    if (!imageSrc) {
        return null;
    }

    return (
        <img
            src={imageSrc}
            alt={isWhitelabel ? 'Logo' : 'TCC online'}
            style={style}
        />
    );
}

function resolveImageSrc(
    companyLogoUrl: string | null,
    isWhitelabel: boolean,
    isWide: boolean,
): string | null {
    if (companyLogoUrl) {
        return companyLogoUrl;
    }

    if (isWhitelabel) {
        return null;
    }

    if (isWide) {
        return logo_wide;
    }

    return logo;
}
